import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as Sentry from "@sentry/react";

// Initialize Sentry error monitoring (will only activate if DSN is set)
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn && sentryDsn !== 'your-sentry-dsn-here') {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV || 'production',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
  console.log('✓ Sentry initialized');
} else {
  console.warn('⚠ Sentry DSN not configured');
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
